import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import axios from "axios";
import { request } from "@/js/http/http_request";
import { hasRole, isAdminNotConsultant } from "@/js/http/auth.js";
import { getErrorData, handleErrorData, ERROR_DATA, filterVAutocomplete } from "@/js/forms.js";
import { formRules } from "@/js/form_rules.js";
import confirmationComponent from "@/components/modal/ConfirmationDialog.vue";
import ErrorModal from "@/components/modal/ErrorModal.vue";
export default {
  name: "Classification",
  components: {
    confirm: confirmationComponent,
    ErrorModal: ErrorModal
  },
  props: {
    loggedUserData: Object,
    baseModel: Object,
    mode: String,
    isEdit: Boolean
  },
  data: function data() {
    return {
      form: {
        valid: false
      },
      isLoadingClassifications: true,
      existingClassifications: [],
      isShowExisitingClassifications: false,
      manageExistingClassification: {
        form: {
          valid: false
        },
        model: {
          id_classification: null,
          label: ""
        },
        error: {
          delete: null
        }
      },
      saveClassificationCancellationToken: null,
      saveExistingClassificationCancellationToken: null,
      deleteExistingClassificationCancellationToken: null,
      managedExceptions: {
        error: {
          appellation_attached: "At least one appellation is attached this classification. It can't be deleted."
        },
        warning: {
          classification_exists: "A classification with same label already exists."
        }
      },
      formRules: formRules,
      filterVAutocomplete: filterVAutocomplete,
      ERROR_DATA: ERROR_DATA
    };
  },
  computed: {
    canManageAppellations: function canManageAppellations() {
      return hasRole(process.env.VUE_APP_ROLES_MANAGE_APPELLATION);
    },
    isAuthorized: function isAuthorized() {
      return isAdminNotConsultant(this.loggedUserData) && this.canManageAppellations;
    }
  },
  created: function created() {
    var _this2 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (_this2.isAuthorized) {
              _context.next = 3;
              break;
            }
            _this2.cancel();
            return _context.abrupt("return");
          case 3:
            _this2.getClassifications();
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    getClassifications: function getClassifications() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this3.isShowExisitingClassifications = false;
              _this3.isLoadingClassifications = true;
              _this = _this3;
              _context2.next = 5;
              return request("/v1/appellations/classifications", "get", null, true, "api").catch(function (e) {
                _this.isLoadingClassifications = false;
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to load classifications list");
                handleErrorData(_this, errorData);
                throw e;
              });
            case 5:
              response = _context2.sent;
              _this3.isLoadingClassifications = false;
              if (response.data !== null) _this3.existingClassifications = _toConsumableArray(response.data);
            case 8:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    toggleShowClassifications: function toggleShowClassifications() {
      this.isShowExisitingClassifications = !this.isShowExisitingClassifications;
    },
    save: function save() {
      if (!this.isEdit) {
        this.saveClassification("post");
      } else {
        this.saveClassification("put");
      }
    },
    saveClassification: function saveClassification(verb) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _this4$saveClassifica;
        var _this, data, response;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this4.$EventBus.$emit("loading", true);
              (_this4$saveClassifica = _this4.saveClassificationCancellationToken) === null || _this4$saveClassifica === void 0 || _this4$saveClassifica.cancel();
              _this4.saveClassificationCancellationToken = axios.CancelToken.source();
              _this = _this4;
              data = {
                id: _this.baseModel.id_classification,
                name: _this.baseModel.label
              };
              _context3.prev = 5;
              _context3.next = 8;
              return request("/v1/appellations/classifications", verb, data, true, "api", null, _this.saveClassificationCancellationToken).catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to save classification");
                handleErrorData(_this, errorData);
                throw e;
              });
            case 8:
              response = _context3.sent;
              if (response.status == 201 || response.status == 200) {
                _this4.$toasted.show("Classifcation saved.", {
                  type: "success"
                });
                _this4.$EventBus.$emit("loading", false);
                _this4.$emit("saved", response.data ? response.data : _this4.baseModel.id_classification);
              }
              _context3.next = 14;
              break;
            case 12:
              _context3.prev = 12;
              _context3.t0 = _context3["catch"](5);
            case 14:
              _this4.$EventBus.$emit("loading", false);
            case 15:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[5, 12]]);
      }))();
    },
    saveEditExistingClassification: function saveEditExistingClassification() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var _this5$saveExistingCl;
        var _this, data, response;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _this5.$EventBus.$emit("loading", true);
              (_this5$saveExistingCl = _this5.saveExistingClassificationCancellationToken) === null || _this5$saveExistingCl === void 0 || _this5$saveExistingCl.cancel();
              _this5.saveExistingClassificationCancellationToken = axios.CancelToken.source();
              _this = _this5;
              data = {
                id: _this.manageExistingClassification.model.id_classification,
                name: _this.manageExistingClassification.model.label
              };
              _context4.prev = 5;
              _context4.next = 8;
              return request("/v1/appellations/classifications", "put", data, true, "api", null, _this.saveExistingClassificationCancellationToken).catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to save classification");
                handleErrorData(_this, errorData);
                throw e;
              });
            case 8:
              response = _context4.sent;
              if (!(response.status == 201 || response.status == 200)) {
                _context4.next = 14;
                break;
              }
              _this.$toasted.show("Classification saved.", {
                type: "success"
              });
              _context4.next = 13;
              return _this.getClassifications();
            case 13:
              _this5.closeEditExistingClassification();
            case 14:
              _context4.next = 18;
              break;
            case 16:
              _context4.prev = 16;
              _context4.t0 = _context4["catch"](5);
            case 18:
              _this5.$EventBus.$emit("loading", false);
            case 19:
            case "end":
              return _context4.stop();
          }
        }, _callee4, null, [[5, 16]]);
      }))();
    },
    cancel: function cancel() {
      this.$emit("cancel");
    },
    deleteClassification: function deleteClassification(id_classification) {
      var _this6 = this;
      this.$refs.confirm.open("Delete", "Are you sure you want to delete this classification ?", {
        color: "red"
      }).then(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6(confirm) {
          var _this6$deleteExisting, _this;
          return _regeneratorRuntime().wrap(function _callee6$(_context6) {
            while (1) switch (_context6.prev = _context6.next) {
              case 0:
                if (!confirm) {
                  _context6.next = 17;
                  break;
                }
                _this6.closeEditExistingClassification();
                _context6.prev = 2;
                _this6.$EventBus.$emit("loading", true);
                (_this6$deleteExisting = _this6.deleteExistingClassificationCancellationToken) === null || _this6$deleteExisting === void 0 || _this6$deleteExisting.cancel();
                _this6.deleteExistingClassificationCancellationToken = axios.CancelToken.source();
                _this = _this6;
                _context6.next = 9;
                return request("/v1/appellations/classifications/".concat(id_classification), "delete", null, true, "api", null, _this6.deleteExistingClassificationCancellationToken).catch(/*#__PURE__*/function () {
                  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5(e) {
                    var errorData;
                    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
                      while (1) switch (_context5.prev = _context5.next) {
                        case 0:
                          errorData = getErrorData(e, _this.managedExceptions, "Unable to delete classification");
                          handleErrorData(_this, errorData);
                          if ((errorData === null || errorData === void 0 ? void 0 : errorData.code) === "appellation_attached") {
                            _this.getErrorAppellationsAttached(id_classification);
                          }
                          throw e;
                        case 4:
                        case "end":
                          return _context5.stop();
                      }
                    }, _callee5);
                  }));
                  return function (_x2) {
                    return _ref2.apply(this, arguments);
                  };
                }());
              case 9:
                _this6.getClassifications();
                _this6.closeEditExistingClassification();
                _this6.$toasted.show("Classifcation deleted", {
                  type: "success"
                });
                _context6.next = 16;
                break;
              case 14:
                _context6.prev = 14;
                _context6.t0 = _context6["catch"](2);
              case 16:
                _this6.$EventBus.$emit("loading", false);
              case 17:
              case "end":
                return _context6.stop();
            }
          }, _callee6, null, [[2, 14]]);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    getErrorAppellationsAttached: function getErrorAppellationsAttached(id_classification) {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var response;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return request("/v1/appellations/classifications/".concat(id_classification, "/appellations"), "get", null, true, "api");
            case 2:
              response = _context7.sent;
              if (response.data !== null) {
                _this7.manageExistingClassification.error.delete = {
                  id_classification: id_classification,
                  code: "appellation_attached",
                  data: _toConsumableArray(response.data),
                  isDetailsShown: false
                };
              }
            case 4:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    toggleShowErrorDeleteAppellationAttached: function toggleShowErrorDeleteAppellationAttached() {
      this.manageExistingClassification.error.delete.isDetailsShown = !this.manageExistingClassification.error.delete.isDetailsShown;
    },
    startEditClassification: function startEditClassification(id_classification) {
      this.manageExistingClassification.model = _objectSpread({}, this.existingClassifications.find(function (x) {
        return x.id_classification === id_classification;
      }));
      this.resetErrorsManagingExisting();
    },
    closeEditExistingClassification: function closeEditExistingClassification() {
      this.manageExistingClassification.model = {
        id_classification: null,
        label: ""
      };
      this.resetErrorsManagingExisting();
    },
    resetErrorsManagingExisting: function resetErrorsManagingExisting() {
      this.manageExistingClassification.error = {
        delete: null
      };
    }
  }
};